
  import { computePosition, offset, shift, flip } from '@floating-ui/dom'

  export default {
    name: 'BaseTooltip',
    props: {
      content: {
        type: String,
        default: '',
      },
      mainTitle: {
        type: String,
        default: '',
      },
      postName: {
        type: String,
        default: '',
      },
      carType: {
        type: String,
        default: '',
      },
      servicesPost: {
        type: Number,
        default: null,
      },
      textPostName: {
        type: String,
        default: '',
      },
      textCarType: {
        type: String,
        default: '',
      },
      /** ID контейнера (например диалога), в который переносить тултип, чтобы он рисовался поверх */
      portalTargetId: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isOpen: false,
        x: 0,
        y: 0,
        strategy: 'absolute',
        currentPlacement: 'top',
      }
    },
    computed: {
      tooltipStyle() {
        return {
          position: this.strategy,
          top: `${this.y}px`,
          left: `${this.x}px`,
        }
      },
    },
    watch: {
      disabled(isDisabled, wasDisabled) {
        if (isDisabled === wasDisabled) return
        if (isDisabled) {
          this.hide()
          this.removeEventListeners()
        } else {
          this.addEventListeners()
        }
      },
    },
    mounted() {
      if (!this.disabled) {
        this.addEventListeners()
      }
      this.addResizeListener()
    },
    beforeDestroy() {
      this.moveFloatingBack()
      this.removeEventListeners()
      this.removeResizeListener()
    },
    methods: {
      addEventListeners() {
        this.$refs.reference.addEventListener('mouseenter', this.show)
        this.$refs.reference.addEventListener('mouseleave', this.hide)
        this.$refs.reference.addEventListener('mousemove', this.handleMouseMove)

        this.$refs.reference.addEventListener('click', this.handleClick)
      },

      removeEventListeners() {
        if (this.$refs.reference) {
          this.$refs.reference.removeEventListener('mouseenter', this.show)
          this.$refs.reference.removeEventListener('mouseleave', this.hide)
          this.$refs.reference.removeEventListener(
            'mousemove',
            this.handleMouseMove
          )
          this.$refs.reference.removeEventListener('click', this.handleClick)
        }
      },

      handleClick() {
        if (!this.isOpen) {
          this.show()
        }
      },

      addResizeListener() {
        window.addEventListener('resize', this.handleResize)
      },

      removeResizeListener() {
        window.removeEventListener('resize', this.handleResize)
      },

      handleResize() {
        this.hide()
      },

      handleMouseMove(event) {
        if (!this.$refs.reference) return
        const rect = this.$refs.reference.getBoundingClientRect()
        const mouseX = event.clientX - rect.left
        const mouseY = event.clientY - rect.top

        const relativeX = mouseX / rect.width
        const relativeY = mouseY / rect.height

        if (relativeY < 0.3) {
          this.currentPlacement = 'top'
        } else if (relativeY > 0.7) {
          this.currentPlacement = 'bottom'
        } else if (relativeX < 0.5) {
          this.currentPlacement = 'left'
        } else {
          this.currentPlacement = 'right'
        }

        if (this.isOpen) {
          this.updatePosition()
        }
      },

      show() {
        if (this.disabled) return
        this.isOpen = true
        this.$nextTick(() => {
          this.updatePosition()
          this.moveFloatingToPortal()
        })
      },

      hide() {
        this.moveFloatingBack()
        this.isOpen = false
      },

      moveFloatingToPortal() {
        const targetId = this.portalTargetId
        if (!targetId) return
        const floating = this.$refs.floating
        if (!floating) return
        const parent = floating.parentNode
        const el = document.getElementById(targetId)
        if (!el || parent === el) return
        this._tooltipTriggerParent = parent
        el.appendChild(floating)
      },

      moveFloatingBack() {
        const floating = this.$refs.floating
        if (floating && this._tooltipTriggerParent) {
          this._tooltipTriggerParent.appendChild(floating)
          this._tooltipTriggerParent = null
        }
      },

      async updatePosition() {
        if (!this.$refs.reference || !this.$refs.floating) return

        const { x, y } = await computePosition(
          this.$refs.reference,
          this.$refs.floating,
          {
            strategy: 'fixed',
            placement: this.currentPlacement,
            middleware: [
              offset(8),
              shift({ padding: 5 }),
              flip({
                fallbackPlacements: ['top', 'right', 'bottom', 'left'],
                padding: 5,
              }),
            ],
          }
        )

        this.x = x
        this.y = y
        this.strategy = 'fixed'
      },
    },
  }
